import React, { useEffect, useState } from 'react';
import { fetchTechServicesSelect } from '../services/techServicesService';
import { changeTechServiceOnServiceRecord } from '../services/serviceRecordsService';
import { useConfirmDialog } from '../contexts/ConfirmContext';

const getErrorMessage = (err, fallback) => {
  const message = err?.message || err?.mesaj || err?.data?.mesaj;
  return message || fallback;
};

const TeknikServisDegistirModal = ({
  isOpen,
  recordId,
  customerName = '—',
  currentTsId = null,
  currentTsAd = '—',
  onClose,
  onSuccess,
}) => {
  const { confirm } = useConfirmDialog();
  const [list, setList] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [listLoading, setListLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen || !recordId) return;
    setSelectedId('');
    setError('');
    setListLoading(true);
    (async () => {
      try {
        const res = await fetchTechServicesSelect({ aktif: true });
        const raw = res?.veri?.teknikServisler || res?.veri || res?.data || [];
        const arr = Array.isArray(raw) ? raw : [];
        setList(
          arr.filter((ts) => {
            const id = String(ts.id || ts._id || '');
            return id && (!currentTsId || id !== String(currentTsId));
          }),
        );
      } catch (err) {
        setError(getErrorMessage(err, 'Teknik servis listesi yüklenemedi'));
        setList([]);
      } finally {
        setListLoading(false);
      }
    })();
  }, [isOpen, recordId, currentTsId]);

  if (!isOpen) return null;

  const handleClose = () => {
    if (submitting) return;
    onClose?.();
  };

  const handleSubmit = async () => {
    if (!recordId || !selectedId) {
      setError('Teknik servis seçin');
      return;
    }
    const confirmed = await confirm({
      title: 'Teknik servis değişikliği',
      message:
        'Bu servis kaydı için teknik servis değiştirilecek. Hazır randevu varsa iptal edilecektir.',
      variant: 'danger',
      confirmLabel: 'Değiştir',
    });
    if (!confirmed) return;

    setSubmitting(true);
    setError('');
    try {
      await changeTechServiceOnServiceRecord(recordId, selectedId);
      window.showNotification?.('success', 'Teknik servis ataması güncellendi');
      onSuccess?.();
      onClose?.();
    } catch (err) {
      setError(getErrorMessage(err, 'Teknik servis değiştirilemedi'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: 16,
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: 24,
          width: '100%',
          maxWidth: 480,
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600 }}>
          Teknik Servis Atamasını Değiştir
        </h2>
        <p style={{ margin: '0 0 16px', fontSize: 14, color: 'var(--text-gray)' }}>
          {customerName}
        </p>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 13, color: 'var(--text-gray)', marginBottom: 4 }}>
            Mevcut teknik servis
          </div>
          <div
            style={{
              padding: '10px 12px',
              borderRadius: 8,
              background: '#f8fafc',
              border: '1px solid var(--border-color)',
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            {currentTsAd}
          </div>
        </div>
        <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 8 }}>
          Yeni teknik servis
        </label>
        <select
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          disabled={listLoading || submitting}
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--border-color)',
            fontSize: 14,
            background: '#fff',
            boxSizing: 'border-box',
          }}
        >
          <option value="">
            {listLoading ? 'Yükleniyor…' : 'Teknik servis seçin'}
          </option>
          {list.map((ts) => {
            const id = ts.id || ts._id;
            const label = `${ts.ad || ts.name || '—'}${ts.kod != null && ts.kod !== '' ? ` (${ts.kod})` : ''}`;
            return (
              <option key={id} value={id}>
                {label}
              </option>
            );
          })}
        </select>
        {!listLoading && list.length === 0 && (
          <div style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>
            Seçilebilir teknik servis bulunamadı
          </div>
        )}
        {error && (
          <div style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{error}</div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
          <button type="button" className="secondary-btn" onClick={handleClose} disabled={submitting}>
            İptal
          </button>
          <button
            type="button"
            className="primary-btn"
            onClick={handleSubmit}
            disabled={submitting || !selectedId || listLoading}
          >
            {submitting ? 'Kaydediliyor…' : 'Değiştir'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeknikServisDegistirModal;
